const stringToJSON = n => ( typeof n === "string" && n?.indexOf('{') !== -1 ) ? JSON.parse( n ) : n;
export default stringToJSON;